<template>
  <div>
    <div
      v-popover:popover
      class="notification-area"
      title="Thông báo"
      @click="showNoti"
      v-click-outside="clickOutsideCloseNoti"
    >
      <el-badge :value="totalUnreadNoti" :max="99" class="item" v-if="totalUnreadNoti != 0">
        <i class="icon24-Notification"></i>
      </el-badge>
      <i class="icon24-Notification" v-else></i>
    </div>
    <el-popover
      ref="popover"
      placement="bottom"
      width="380"
      trigger="manual"
      v-model="visible"
    >
      <div
        class="list-noti-popover"
        id="list-noti-popover"
        v-infinite-scroll="loadNotification"
        infinite-scroll-disabled="busy"
      >
        <div class="noti-popover-header">
          <div class="noti-popover-title">Thông báo</div>
          <el-dropdown
            trigger="click"
            placement="bottom-end"
            popper-class="noti-popover-dropdown-menu"
            @command="handleNotiMenuCommand"
          >
            <button
              class="noti-popover-more"
              type="button"
              aria-label="Tùy chọn thông báo"
              @click.stop
            >
              ...
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="GENERAL_NOTIFICATION">
                <span class="noti-dropdown-item">
                  <span
                    class="noti-dropdown-check"
                    :class="{ active: selectedNotiMenuCommand === 'GENERAL_NOTIFICATION' }"
                  ></span>
                  <span>Tất cả thông báo</span>
                </span>
              </el-dropdown-item>
              <el-dropdown-item command="DOC_APPROVED">
                <span class="noti-dropdown-item">
                  <span
                    class="noti-dropdown-check"
                    :class="{ active: selectedNotiMenuCommand === 'DOC_APPROVED' }"
                  ></span>
                  <span>Văn bản phê duyệt</span>
                </span>
              </el-dropdown-item>
              <el-dropdown-item command="TIMEKEEPING_NOTIFICATION">
                <span class="noti-dropdown-item">
                  <span
                    class="noti-dropdown-check"
                    :class="{ active: selectedNotiMenuCommand === 'TIMEKEEPING_NOTIFICATION' }"
                  ></span>
                  <span>Thông báo chấm công</span>
                </span>
              </el-dropdown-item>
              <el-dropdown-item
                command="MARK_ALL_AS_READ"
                :disabled="!totalUnreadNoti"
                divided
              >
                <span class="noti-dropdown-item">
                  <span
                    class="noti-dropdown-check"
                    :class="{ active: selectedNotiMenuCommand === 'MARK_ALL_AS_READ' }"
                  ></span>
                  <span>Đánh dấu tất cả là đã đọc</span>
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <template v-if="lstNotifications && lstNotifications.length">
          <div
            v-for="(item, index) in lstNotifications"
            :key="index"
            :class="{
              'list-noti-popover--item': true,
              unread: !item.isRead,
            }"
            @click="goTo(item.content)"
          >
            <div
              :class="{
                icon: true,
                system: item.content.data.type,
                timekeeping: !item.content.data.type,
              }"
            >
              <i
                :class="{
                  'icon24-VB_DaChoYKien': item.content.data.type,
                  'icon24-LichSu': !item.content.data.type,
                }"
              ></i>
            </div>
            <div class="content">
              <p class="message font-weight-bold">{{ item.content.title }}</p>
              <p class="message text-overflow-2-line" :title="item.content.message">
                {{ item.content.message }}
              </p>
              <p class="created-time text-right">
                {{ formatDateTime(item.createdTime) }}
              </p>
            </div>
          </div>
        </template>
        <div v-else class="list-noti-popover--empty">Không có thông báo nào</div>
      </div>
      <div class="stage" v-if="loading">
        <div class="dot-pulse"></div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import MethodService from "@/service/MethodService";
import NotificationApi from "@/moduleApi/NotificationApi";
import DraffDocumentAutoApi from "@/moduleApi/DraffDocumentAutoApi";
import EventBus from "@/service/EventBus";
import DocumentApi from "@/moduleApi/DocumentApi";

export default {
  data() {
    return {
      currentUser: MethodService.getCurrentUser(),
      listNotifications: [],
      limit: 0,
      total: 21,
      loading: false,
      visible: false,
      totalUnreadNoti: 0,
      isSigner: false,
      currentDocStatus: "",
      selectedNotiMenuCommand: "",
    };
  },
  computed: {
    // A computed property that returns a boolean value. It is used to check if the limit is greater
    // than or equal to the total.
    noMore() {
      return this.limit >= this.total;
    },
    // A computed property that returns a boolean value. It is used to check if the limit is greater
    // than or equal to the total.
    busy() {
      return this.loading || this.noMore;
    },

    lstNotifications() {
      const selected = this.selectedNotiMenuCommand;
      if (!selected || selected === "GENERAL_NOTIFICATION") return this.listNotifications;

      const getType = (noti) =>
        noti && noti.content && noti.content.data ? noti.content.data.type : "";

      const isDocumentNoti = (type) => {
        if (!type || typeof type !== "string") return false;
        return type.startsWith("DOC_") || type.startsWith("SIGN_") || type.includes("DOCUMENT_AUTO");
      };

      const timekeepingTypes = new Set([
        "APPROVED_WORK_A_DAY",
        "APPROVED_WORK_A_MONTH",
        "DAY_OFF",
        "GO_LATE",
        "COME_BACK_SOON",
        "WORK_EXPLANATION",
        "GO_OUT",
        "GO_ON_BUSSINESS",
        "TIME_KEEPING_ONLINE",
        "OT",
      ]);

      const isTimekeepingNoti = (type) => timekeepingTypes.has(type);

      if (selected === "DOC_APPROVED") {
        return this.listNotifications.filter((n) => isDocumentNoti(getType(n)));
      }

      if (selected === "TIMEKEEPING_NOTIFICATION") {
        return this.listNotifications.filter((n) => isTimekeepingNoti(getType(n)));
      }

      return this.listNotifications;
    },
  },
  methods: {
    // A function that is called when the component is created. It will call the API to get the
    // list of notifications.
    async getListNoti() {
      const notiApiRes = await NotificationApi.list(
        {
          filters: `toUserId=${this.currentUser.id}&env!=1`,
          limit: this.limit,
          sort: "-createdTime",
        },
        true
      );
      setTimeout(() => {
        this.listNotifications = notiApiRes.result;
        this.total = notiApiRes.meta.total;
        this.loading = false;
      }, 1000);
    },
    async getTotalUnreadNoti() {
      const notiApiRes = await NotificationApi.list(
        {
          filters: `toUserId=$$user_id&isRead!=true&env!=1`,
          fields: "id,isRead,toUserId,env",
          limit: 99999,
        },
        true
      );
      if (notiApiRes.result) this.totalUnreadNoti = notiApiRes.meta.total;
    },
    // A method that is being called in the Vue HTML.
    loadNotification() {
      if (this.busy) return;
      this.loading = true;
      this.limit += 20;
      this.getListNoti();
    },
    // A method that is being called in the Vue HTML.
    formatDateTime(value) {
      return MethodService.formatDate(value, "datetime");
    },
    // A method that is being called in the Vue HTML. It is used to show the notification popover.
    showNoti() {
      this.visible = !this.visible;
      this.limit = 0;
      this.loadNotification();
      if (this.visible) {
        this.getTotalUnreadNoti();
      }
    },
    clickOutsideCloseNoti() {
      if (this.visible) {
        this.visible = false;
      }
    },
    // This function is used to redirect the user to the corresponding page when they click on a
    // notification.
    async goTo(item) {
      this.currentDocStatus = '',
      this.visible = false;
      await this.fn_readNoti(item.data.notification_id);
      if (["DOC_REQUEST_FOR_SIGN_AGAIN", "DOC_REQUEST_FOR_DFAFF_SIGN_AGAIN"].includes(item.data.type)) {
        window.toastr.info(item.message || "Bạn đã được rút khỏi danh sách ký của văn bản này.");
        return;
      }
      this.getTotalUnreadNoti();
      this.getListNoti();
      await this.fn_checkDocumentStatus(item.data.id, item.data.type);
      if (
        item.data.type == "LUNCH_REGISTRATION_WEEKLY_REMINDER" ||
        item.data.type == "LUNCH_REGISTRATION_DAILY_REMINDER"
      ) {
        this.$router
          .push({
            name: "Admin-LunchRegistration",
            query: { weekStart: item.data.id },
          })
          .catch((err) => {});
      }
      // News module
      else if (
        item.data.type == "APPROVERED_NEWS" ||
        item.data.type == "NEWS" ||
        item.data.type == "REQUEST_APPROVEL_NEWS"
      ) {
        this.$router
          .push({
            name: "Admin-News-detail",
            params: { id: item.data.id },
          })
          .catch((err) => {});
      } else if (item.data.type == "REQUEST_EDIT_NEWS") {
        this.$router
          .push({
            name: "Admin-News-update",
            params: { id: item.data.id },
          })
          .catch((err) => {});
      }
      // Employee Detail
      else if (item.data.type == "WAITING_FOR_APPROVAL_SALARY") {
        this.$router
          .push({
            name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-detail",
            params: { id: item.data.id },
          })
          .catch((err) => {});
      } else if (
        item.data.type == "APPROVERED_EMPLOYEE_DRAFT" ||
        item.data.type == "REJECT_EMPLOYEE_DRAFT"
      ) {
        this.$router
          .push({
            name: "Admin-EmployeeInfo-detail",
            params: { id: item.data.id },
          })
          .catch((err) => {});
      } else if (
        item.data.type == "CREATED_EMPLOYEE_DRAFT" ||
        item.data.type == "UPDATED_EMPLOYEE_DRAFT"
      ) {
        this.$router
          .push({
            name: "Admin-EmployeeManager-approve",
            params: { id: item.data.id },
          })
          .catch((err) => {});
      }
      // Document module
      else if (
        item.data.type == "DOC_REQUEST_FOR_SIGN" ||
        item.data.type == "DOC_REQUEST_FOR_SIGN_AGAIN"
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: item.data.id },
            query: {
              type: "DOC_SIGN_CONSENT",
            },
          })
          .catch((err) => {});
      } else if (
        item.data.type == "DOC_PUBLISHED" ||
        (item.data.type == "DOC_TRANSFER" &&
          (this.currentDocStatus !== "PUBLISHED" ||
            this.currentDocStatus !== "NEW" ||
            this.currentDocStatus !== "SIGNED" ||
            this.currentDocStatus !== "RECALLED" ||
            this.currentDocStatus !== "TRANSFERED_OTHER_COMPANY"))
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: item.data.id },
            query: {
              type: "DOC_IN",
            },
          })
          .catch((err) => {});
      } else if (
        item.data.type == "DOC_REQUEST_FOR_DFAFF_SIGN" ||
        item.data.type == "DOC_REQUEST_FOR_DFAFF_SIGN_AGAIN"
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: item.data.id },
            query: {
              type: "DOC_SIGN_TEMP",
            },
          })
          .catch((err) => {});
      } else if (
        item.data.type == "DOC_SIGNED" ||
        (item.data.type == "DOC_TRANSFER" &&
          (this.currentDocStatus == "PUBLISHED" ||
            this.currentDocStatus == "SIGNED" ||
            this.currentDocStatus == "RECALLED" ||
            this.currentDocStatus == "TRANSFERED_OTHER_COMPANY"))
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: item.data.id },
            query: {
              type: "DOC_OUT",
            },
          })
          .catch((err) => {});
      } else if (
        item.data.type == "DOC_REJECTED" ||
        item.data.type == "DOC_RECALLED" ||
        (item.data.type == "DOC_TRANSFER" &&
          (this.currentDocStatus == "NEW" ||
            this.currentDocStatus == "WAITING_FOR_SIGN" ||
            this.currentDocStatus == "REJECT_FOR_SIGN" ||
            this.currentDocStatus == "REJECTED"))
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: item.data.id },
            query: {
              type: "DOC_SIGN",
            },
          })
          .catch((err) => {});
      }
      // Salary module
      else if (item.data.type == "NOTIFICATION_SALARY") {
        this.$router
          .push({
            name: "Admin-SalaryEmployee-list",
          })
          .catch((err) => {});
      } else if (
        item.data.type == "APPROVED_SALARY" ||
        item.data.type == "REJECTED_SALARY"
      ) {
        this.$router
          .push({
            name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-detail",
            params: { id: item.data.id },
          })
          .catch((err) => {});
      }
      // HDDT
      else if (
        item.data.type == "SIGN_REJECTED_DOCUMENT_AUTO" ||
        item.data.type == "SIGN_REQUEST_DOCUMENT_AUTO" ||
        item.data.type == "SIGN_APPROVED_DOCUMENT_AUTO"
      ) {
        await this.fn_currentStatusSigner(item.data.id);
        this.$router
          .push({
            name: `Admin-DocumentDrafting-${
              this.isSigner ? "sign" : "detail"
            }-approve`,
            params: { id: item.data.id },
          })
          .catch((err) => {});
      }
      // Chốt công
      else if (
        item.data.type == "APPROVED_WORK_A_DAY" ||
        item.data.type == "APPROVED_WORK_A_MONTH"
      ) {
        this.$router
          .push({
            name: "Admin-Timekeeping-Employee-EmployeeWorksheet",
            query: { salaryPeriodId: item.data.id },
          })
          .catch((err) => {});
      }
      // Request
      else if (
        item.data.type == "DAY_OFF" ||
        item.data.type == "GO_LATE" ||
        item.data.type == "COME_BACK_SOON" ||
        item.data.type == "WORK_EXPLANATION" ||
        item.data.type == "GO_OUT" ||
        item.data.type == "GO_ON_BUSSINESS" ||
        item.data.type == "TIME_KEEPING_ONLINE" ||
        item.data.type == "OT"
      ) {
        this.$router
          .push({
            name: "Admin-ManageRequests-CheckRequest",
            params: { id: item.data.id },
          })
          .catch((err) => {});
      }
    },
    async fn_checkDocumentStatus(id, notiType) {
      if (!notiType || notiType != "DOC_TRANSFER") return;
      const res = await DocumentApi.findById(id);
      if (res.result) {
        this.currentDocStatus = res.result.status;
      }
    },
    async fn_currentStatusSigner(id) {
      const res = await DraffDocumentAutoApi.findById(id);
      if (res.result && res.result.signers) {
        const isWaitingSign = res.result.signers.findIndex(
          (signer) =>
            signer.user_id == this.currentUser.id && signer.status == "WAITING"
        );
        if (isWaitingSign >= 0) this.isSigner = true;
      }
    },
    // This function is used to update the notification to be read.
    async fn_readNoti(id) {
      let data = {
        id: id,
        isRead: true,
      };
      await NotificationApi.update(data, true);
      await this.getTotalUnreadNoti();
    },

    async markAllAsRead() {
      if (!this.totalUnreadNoti) return;

      await NotificationApi.markAllAsRead({
        toUserId: this.currentUser.id,
      }, true);

      this.listNotifications = this.listNotifications.map((item) => ({
        ...item,
        isRead: true,
      }));
      this.totalUnreadNoti = 0;
      this.getListNoti();
    },

    handleNotiMenuCommand(command) {
      if (command === "MARK_ALL_AS_READ") {
        this.markAllAsRead();
        return;
      }

      this.selectedNotiMenuCommand = command;
    },
  },
  created() {
    this.getTotalUnreadNoti();
    this.loadNotification();
    EventBus.$on("receivedOnMessage", this.getTotalUnreadNoti);
  },
  // Used to add an event listener to the list element. When the user scrolls to the bottom of the
  // list, the `loadNotification()` function will be called.
  mounted() {
    const listElm = document.querySelector("#list-noti-popover");
    listElm.addEventListener("scroll", () => {
      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
        this.loadNotification();
      }
    });
  },
  destroyed() {
    EventBus.$off("receivedOnMessage", this.getTotalUnreadNoti);
  },
};
</script>
<style lang="scss">
.text-overflow-2-line {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  word-break: break-word;
  -webkit-box-orient: vertical;
}

.notification-area {
  height: 48px;
  width: 48px;
  background: #d0e8f5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: #4f8aab;
  }

  &:hover {
    cursor: pointer;
  }
}

.el-popover {
  padding: 5px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px,
    rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px,
    rgba(0, 0, 0, 0.07) 0px 16px 16px;
}

.noti-popover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px 12px;
  border-bottom: 1px solid #ebedf0;
}

.noti-popover-title {
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  color: #292d32;
}

.noti-popover-action {
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: #4f8aab;
  white-space: nowrap;

  &:hover:not(:disabled) {
    cursor: pointer;
    color: #3d6f8b;
  }

  &:disabled {
    color: #b6bcc6;
    cursor: default;
  }
}

.noti-popover-more {
  padding-bottom: 6px;
  border: 0;
  background: transparent;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;

  &:hover {
    cursor: pointer;
    color: #3d6f8b;
  }
}

.noti-popover-dropdown-menu {
  .el-dropdown-menu__item {
    font-size: 14px;
    line-height: 22px;
  }
}

.noti-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.noti-dropdown-check {
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: "✓";
    visibility: hidden;
  }

  &.active::before {
    visibility: visible;
  }
}

.list-noti-popover {
  max-height: calc(100vh - 125px);
  overflow-y: auto;

  &--empty {
    padding: 16px 10px;
    font-size: 14px;
    line-height: 22px;
    color: #8a8a8a;
    text-align: center;
  }

  &--item {
    display: grid;
    grid-template-columns: 60px auto;
    align-self: center;
    padding: 10px 15px 10px 10px;
    border-radius: 8px;
    margin-bottom: 5px;

    &.unread {
      background: #f1f1f1;
    }

    .icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: center;

      &.system {
        background: #ff5621;
      }

      &.timekeeping {
        background: #f79e61;
      }

      [class^="icon24-"],
      [class*=" icon24-"] {
        color: #fff;
        font-size: 32px;
      }
    }

    .content {
      align-self: center;

      .message {
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        color: #292d32;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // -webkit-line-clamp: 2;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        word-break: break-word;
      }

      .created-time {
        font-weight: 200;
        font-size: 13px;
        line-height: 16px;
        color: #444242;
      }
    }

    &:hover {
      cursor: pointer;
      background: #fcf1e4;
    }
  }
}

.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 15px 0 8px;
  overflow: hidden;
}

.dot-pulse {
  position: relative;
  left: -9999px;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: #000000;
  color: #000000;
  box-shadow: 9999px 0 0 -5px;
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;
}

.dot-pulse::before,
.dot-pulse::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: #000000;
  color: #000000;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px;
  animation: dot-pulse-before 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px;
  animation: dot-pulse-after 1.5s infinite linear;
  animation-delay: 0.5s;
}

@keyframes dot-pulse-before {
  0% {
    box-shadow: 9984px 0 0 -5px;
  }

  30% {
    box-shadow: 9984px 0 0 2px;
  }

  60%,
  100% {
    box-shadow: 9984px 0 0 -5px;
  }
}

@keyframes dot-pulse {
  0% {
    box-shadow: 9999px 0 0 -5px;
  }

  30% {
    box-shadow: 9999px 0 0 2px;
  }

  60%,
  100% {
    box-shadow: 9999px 0 0 -5px;
  }
}

@keyframes dot-pulse-after {
  0% {
    box-shadow: 10014px 0 0 -5px;
  }

  30% {
    box-shadow: 10014px 0 0 2px;
  }

  60%,
  100% {
    box-shadow: 10014px 0 0 -5px;
  }
}
</style>
